import React, { FC } from 'react';

import { Control } from 'react-hook-form';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import Input from '../../../../components/Input/Input';
import InputSelectDropdown from '../../../../components/InputSelectDropdown/InputSelectDropdown';
import RichText from '../../../../components/RichText/RichText';
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage
} from '../../../../components/ui';
import { POPUPS_FORM_SALE_TYPE_OPTIONS, PopupsFormFields } from '../constants';

type SaleAndDiscountsSectionProps = {
  control: Control<PopupsFormFields>;
  currentPriceDiscount: string;
};

const SaleAndDiscountsSection: FC<SaleAndDiscountsSectionProps> = ({
  control,
  currentPriceDiscount
}) => (
  <div>
    <RichText
      title="Sale & Discounts"
      description="Enhance your offer by providing greater value at a better price"
      className="mb-5"
    />
    <div className="grid grid-cols-2 gap-5 pb-5 border-b border-base-sidebarBorder w-full">
      <FormField
        control={control}
        name="discount"
        render={({ field: { value, onChange } }) => (
          <FormItem>
            <FormControl>
              <Input
                name="priceDiscount"
                leftIcon={<FontAwesomeIcon icon="fa-regular fa-percent" />}
                label="Price Discount"
                type="number"
                min={0}
                value={value}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === '') {
                    onChange('');
                  } else {
                    onChange(e.target.valueAsNumber);
                  }
                }}
                placeholder="% 0"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="priceDiscountType"
        render={({ field: { onChange } }) => (
          <FormItem>
            <FormControl>
              <InputSelectDropdown
                disabled
                label="Type"
                defaultSelected={POPUPS_FORM_SALE_TYPE_OPTIONS.find(
                  (option) => option.value === currentPriceDiscount
                )}
                options={POPUPS_FORM_SALE_TYPE_OPTIONS}
                onOptionChange={onChange}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  </div>
);

export default SaleAndDiscountsSection;
